import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {MatSlideToggleChange} from '@angular/material/slide-toggle';
import {ApiId, DistributionAccount, TtdPriceModel} from '../../../../distribution-account/distribution-account.model';
import {MultiShareValidationService} from '../../../../segment-multi-share/multi-share-validation.service';
import {TargetService, TtdBuyable, TtdCategory, TtdConfig} from '../../../../target/target.service';
import {SubscriptionHandler} from '../../../../utils/subscription-handler';
import {SegmentRemoveShareDialogComponent} from '../../../share/remove-share-dialog.component';
import {TheTradeDeskShareConfig} from '../../../../segment-multi-share/segment-share.service';
import {map, shareReplay} from 'rxjs/operators';
import {Segment} from '../../../segment.model';
import {FormControl} from '@angular/forms';

@Component({
  selector: 'app-segment-info-target-ttd',
  template: `
    <div class="logo"></div>
    <ng-container *ngIf="segments && selectedCategory && account?.apiId === 'TTD_DATA_ALLIANCE'"
                  style="max-height: 200px;overflow-scrolling: auto">
      <mat-card style="width: 100%;max-height: 250px;overflow:auto">
        <span class="typo-title">Segment name overrides</span>
        <mat-card-content
          style="display: flex;flex-direction: column;align-items: center;justify-content: space-between;">
          <div style="width: 100%" *ngFor="let segment of segments">
            <mat-form-field style="width: 80%" appearance="outline">
              <mat-label>ID({{ segment.id }}) {{ segment.name }}</mat-label>
              <input name="{{segment.name}}" [formControl]="getDynamicControl(segment)" matInput>
            </mat-form-field>
          </div>
        </mat-card-content>
      </mat-card>

    </ng-container>

    <mat-card *ngIf="!isDryMode">
      <span class="typo-title">Settings</span>
      <mat-card-content class="flex-row">
        <span>Is Active / Buyable: </span>
        <mat-slide-toggle (change)="handleBuyableChange($event)"
                          [checked]="buyableStatus?.buyable"
                          [disabled]="!buyableStatus || buyableUpdatePending"
                          color="accent"></mat-slide-toggle>
      </mat-card-content>
    </mat-card>
    <ng-container *ngIf="account && account.ttdCategoryId">
      <mat-card>
        <mat-card-content>
          <div>
            <div class="flex-row">
              <span class="typo-title">Category</span>
            </div>

            <div class="flex-row">
              <a [queryParams]="{id: account.ttdCategoryId}" mat-icon-button routerLink="/ttd/category">
                <span class="mat-caption">{{ getCategoryName() }} (TTD-ID: {{ account.ttdCategoryId }})</span>
                <mat-icon>open_in_new</mat-icon>
              </a>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </ng-container>
    <ng-container *ngIf="account && account.ttdCompliance">
      <mat-card>
        <mat-card-content>
          <div>
            <div class="flex-row">
              <span class="typo-title">Compliance status</span>
            </div>

            <div class="flex-row">
              {{ account.ttdCompliance }}
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </ng-container>
    <ng-container *ngIf="account && account.ttdDisplayName">
      <mat-card>
        <mat-card-content>
          <div>
            <div class="flex-row">
              <span class="typo-title">TheTradeDesk Segment Name</span>
            </div>

            <div class="flex-row" *ngIf="!inInputState" (click)="changeToNameChangeInput()">
              {{ account.ttdDisplayName }}
            </div>
            <div style="display: flex;flex-direction: row;width: 100%" *ngIf="inInputState">
              <mat-form-field appearance="outline" style="width: 80%">
                <input name="ttdDisplayName" [formControl]="nameChangeControl" matInput
                       [autofocus]="true">
              </mat-form-field>
              <button
                style="max-height: 40px; margin: 15px"
                mat-raised-button
                color="accent"
                name="change-ttd-name"
                (click)="changeName()">Save
              </button>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </ng-container>

    <div *ngIf="isDryMode" id="cat-container">
      <div class="flex-row">
        <span class="typo-title">Category</span>
      </div>
      <app-segment-share-item-ttd [accountValue]="categoryHolder"
                                  [categories]="ttdCategories | async"
                                  (changed)="emitChange()"
                                  [hideAccountSelectCheckBox]="true"></app-segment-share-item-ttd>
    </div>
    <app-ttd-segment-prices [prices]="this.account.ttdPricing ? this.account.ttdPricing : []"
                            [partners]="partners | async"
                            [accountId]="account.id"
                            [apiId]="account.apiId"
                            [ttdConfig]="ttdConfig"
                            [segmentId]="account.segmentId" (pricesChanged)="handlePricesChanged($event)"
                            [isDryMode]="isDryMode"></app-ttd-segment-prices>
  `,
  styleUrls: ['../account/account.component.scss', 'account-ttd.component.scss']
})
export class SegmentInfoAccountTtdComponent implements OnInit, OnDestroy {

  readonly customSegmentCategory = 'custemetriq';

  @Input() account!: DistributionAccount;
  ttdConfig: TtdConfig[] = [];

  @Output() configChange = new EventEmitter<TheTradeDeskShareConfig>();

  categoryHolder: DistributionAccount = {} as DistributionAccount; // TODO: not sure why using account makes this unreactive

  partners = this.targetService.getTtdPartners();
  categories!: TtdCategory[];
  dialogRef!: MatDialogRef<SegmentRemoveShareDialogComponent>;

  buyableStatus!: TtdBuyable;
  buyableUpdatePending = false;
  inInputState = false;

  isDryMode = false;
  ttdCategories = this.targetService.getTtdCategories()
    .pipe(
      shareReplay(1),
      map(it => it.filter(c => c.origin === this.account.apiId))
    );
  pricing: TtdPriceModel[] = [];
  private subscriptionHandler = new SubscriptionHandler();
  @Input() segments: Segment[] = [];
  selectedCategory: TtdCategory | undefined;
  private controls: { [key: number]: FormControl } = {};
  nameChangeControl: FormControl = new FormControl();

  constructor(
    private targetService: TargetService,
    private validation: MultiShareValidationService) {
  }

  ngOnInit(): void {
    this.isDryMode = !this.account.segmentId;
    this.targetService.getTtdConfig().subscribe(it => {
      this.ttdConfig = it;
    });
    if (this.account?.foreignIdForCurrentSegment) {
      this.targetService.getTtdBuyableStatus(
        this.account.foreignIdForCurrentSegment,
        this.account.id
      )
        .subscribe(result => {
          this.buyableStatus = result;
        });
    }
    this.sendValidation();
    this.subscriptionHandler.add(this.ttdCategories.subscribe(it => this.categories = it));
  }

  ngOnDestroy() {
    this.subscriptionHandler.unsubscribe();
  }

  handleBuyableChange(event: MatSlideToggleChange) {
    this.buyableStatus.buyable = event.checked;

    this.buyableUpdatePending = true;
    this.subscriptionHandler.subscription = this.targetService.updateTtdBuyableStatus(this.buyableStatus).subscribe(() => {
      this.buyableUpdatePending = false;
    });
  }

  handlePricesChanged(prices: TtdPriceModel[]) {
    this.pricing = [...prices];
    this.account.ttdPricing = this.pricing;
    this.emitChange();
  }

  public emitChange() {
    if (this.pricing.length === 0) {
      // if no pricing selected - only send category for segment share
      this.configChange.emit({
        categoryId: this.categoryHolder.ttdCategoryId,
        names: this.getSegmentNames()
      } as TheTradeDeskShareConfig);

    } else {
      this.configChange.emit({
        categoryId: this.categoryHolder.ttdCategoryId,
        pricings: this.pricing,
        names: this.getSegmentNames()
      } as TheTradeDeskShareConfig);
    }
    this.selectedCategory = this.categories.find(it => it.providerElementId === this.categoryHolder.ttdCategoryId);

    this.sendValidation();
  }

  private getSegmentNames() {
    return Object.entries(this.controls)
      .reduce((previous, [key, value]) => {
        return {
          ...previous,
          [key]: value.value
        };
      }, <{ [key: number]: string }>{});
  }

  getCategoryName() {
    return this.categories.find(it => it.providerElementId === this.account.ttdCategoryId)?.displayName;
  }

  private sendValidation() {
    this.validation.notifyValidate({
      valid: this.categoryHolder.ttdCategoryId !== undefined,
      key: `ttd_${this.account.id}_1`,
      hint: `${this.account.description} needs a category`
    });

    if (this.categoryHolder.ttdCategoryId === this.customSegmentCategory) {

      this.validation.notifyValidate({
        valid: this.pricing.length > 0,
        key: `ttd_${this.account.id}_2`,
        hint: `${this.account.description} needs a price`
      });

    }

  }

  getDynamicControl(segment: Segment) {
    if (this.controls[segment.id]) {
      return this.controls[segment.id];
    }
    const newSegmentControl = new FormControl('');
    newSegmentControl.setValue(this.selectedCategory?.displayName + ' > ' + segment.name);
    this.controls[segment.id] = newSegmentControl;
    this.subscriptionHandler.add(newSegmentControl.valueChanges.subscribe(value => this.emitChange()));
    return newSegmentControl;
  }

  protected readonly ApiId = ApiId;

  changeToNameChangeInput() {
    this.inInputState = true;
    this.nameChangeControl.setValue(this.account.ttdDisplayName);
  }

  changeName() {
    this.targetService.updateName(this.account.segmentId, this.nameChangeControl.value,this.account.id).subscribe(() => {
      this.inInputState = false;
      this.account.ttdDisplayName = this.nameChangeControl.value;
    });
  }
}
